import Container from '@/components/Container';
import MarketingSection from './MarketingSection';

export default function MarketingContent({
  content,
}) {
  return (
    <MarketingSection sectionTitle="¿De qué trata?">
      <Container maxWidth="max-w-screen-lg" className="lg:px-20">
        <div className="prose lg:prose-lg" dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </MarketingSection>
  );
}
